/**
 * Namespace for admin services
 */
export const ADMIN_SERVICES_NAMESPACE = 'admin';
